<template>
	<div id="navigace">
		<a class="button pull-right" v-bind:class="{ disabled:disableNext }" @click="onClickNext()" v-show="!showSaveAndQuit && showNext">Pokračovat</a>
		<a class="pull-left" v-bind:class="{ disabled:disablePrev }" @click="onClickPrev()" v-show="!showSaveAndQuit && showPrev">Vrátit se zpět</a>
		<a v-if="showSaveAndQuit" class="button pull-right" @click="onClickSaveAndQuit" >Uložit a odejít</a>
	</div>
</template>

<script>
export default {
  props: {
    onClickPrev: {
      type: Function,
      required: false
    },
    onClickNext: {
      type: Function,
      required: false
    },
    onClickSaveAndQuit: {
      type: Function,
      required: false
    },
    showPrev: {
      type: Boolean,
      required: false,
      default: false
    },
    showNext: {
      type: Boolean,
      required: false,
      default: false
    },
    disablePrev: {
      type: Boolean,
      required: false,
      default: false
    },
    disableNext: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    showSaveAndQuit: function () {
      return this.onClickSaveAndQuit && (window.konfigurator && window.konfigurator.save_and_quit)
    }
  },
}
</script>



// WEBPACK FOOTER //
// Navigace.vue?33e21bc9